import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import PageLayout from "../components/feature/PageLayout";
import Home from "../pages/home/page";
import ListPage from "../pages/list/page";
import ShuyuanPage from "../pages/shuyuan/page";
import DetailPage from "../pages/detail/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PageLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "list", element: <ListPage /> },
      { path: "shuyuan", element: <ShuyuanPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "faq", element: <FaqPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;